<template>
    <div class="policy-form">
        <div class="row">
            <div class="col-12 col-lg-10 mx-auto d-flex flex-column align-items-center">
                <section class="questions w-100">
                    <hr>
                    <div class="row mb-2">
                        <div class="col-12 d-flex">
                            <div class="flex-grow-1">
                                <a :href="routes.cancel" class="mc-back-link float-right mt-2"><svg class="mc-ob-skip-arrow" viewBox="0 0 40 12" aria-hidden="true"><path d="M5 6 L12 1 M5 6 L12 11 M8 6 H39" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Back to {{ vendorTerm }}</a>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <form method="POST" :action="routes.store" class="mb-4" enctype="multipart/form-data" id="baaForm">
                        <input type="hidden" name="_token" :value="csrf_token">
                        <input type="hidden" name="previous_baa" :value="previousBaa">

                        <fieldset>
                            <span role="alert" aria-hidden="true" class="baa-feedback text-success d-none"><strong>Saving...</strong></span>
                            <div class="baa-step-head">How do you want to create this BAA?</div>
                            <div class="row">
                                <div class="form-group col-12 col-md-8">
                                    <select class="form-control w-100" name="type" id="type" @change="changeType" v-model="templateType">
                                        <option v-for="(label, type) in baaTypes" :value="type">{{ label }}</option>
                                    </select>
                                    <small class="form-text text-muted">Most people start from a Medcurity or saved template. You can also upload a signed BAA or write a custom one.</small>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset v-if="templateType">

                            <BaaCustomInputs v-if="templateType === 'custom'"></BaaCustomInputs>
                            <BaaUploadInputs v-else-if="templateType === 'upload'"></BaaUploadInputs>
                            <BaaMedcurityInputs v-else-if="templateType === 'medcurity'" :medcurity-script-stack="medcurityScriptStack"></BaaMedcurityInputs>
                        </fieldset>


                        <div class="row">
                            <div class="col-12 text-right">
                                <a :href="routes.cancel" class="btn btn-secondary mr-4">Cancel</a>
                                <button class="btn btn-primary px-4">Save &amp; continue</button>
                            </div>
                        </div>

                    </form>

                </section>

                <div class="row w-100" v-if="Object.keys(oldValues).length && Object.keys(baaRevisions).length">
                    <div class="col d-flex flex-column align-items-center">
                        <BaaRevisions :baa-revisions="baaRevisions"></BaaRevisions>
                    </div>
                </div>
            </div>
        </div>
        <div id="stickyStop"></div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex'
    import BaaFormNavigator from './BaaFormNavigator'
    import BaaCustomInputs from "./BaaCustomInputs";
    import BaaUploadInputs from "./BaaUploadInputs";
    import BaaMedcurityInputs from "./BaaMedcurityInputs";
    import BaaRevisions from "./BaaRevisions";

    export default {
        name: "BaaFormWizard",
        props: [
            "generalUser",
            "company",
            "vendorTerm",
            "medcurityBaasData",
            "medcurityScriptStack",
            "routes",
            "oldValues",
            "baaRevisions",
            "previousBaa",
            "previousBaas",
            "activeBaa"
        ],
        components:{
            BaaFormNavigator,
            BaaCustomInputs,
            BaaUploadInputs,
            BaaMedcurityInputs,
            BaaRevisions
        },
        data: function(){
            return {
                templateType: 'medcurity',
                baaTypes: {
                    medcurity: "Medcurity or saved template",
                    upload: "Upload a signed BAA",
                    custom: "Write a custom BAA",
                }
            }
        },
        computed:{
            ...mapState('baaForm',[
                'inputs'
            ]),
            csrf_token(){
                return document.head.querySelector('meta[name="csrf-token"]').content
            }
        },
        created(){
            // Item B (Joe, 2026-08-12): populate the store BEFORE child inputs mount.
            // templateType defaults to 'medcurity', so <BaaMedcurityInputs> mounts and
            // runs initInputs() immediately; if the store's oldValues are still empty
            // (set in mounted()) the saved template never pre-selects and the edit /
            // Finish-BAA form loads blank, failing the required-template rule. created()
            // runs before children mount, so oldValues are ready when initInputs() reads them.
            this.initWizard()
        },
        methods: {
            ...mapMutations({
                setMedcurityBaas: 'baaForm/setMedcurityBaas',
                setOldValues: 'baaForm/setOldValues',
                setPreviousBaas: 'baaForm/setPreviousBaas',
                setRoutes: 'baaForm/setRoutes',
		setGeneralUser: 'baaForm/setGeneralUser'
            }),
            ...mapActions('baaForm', [
                'setBaaTemplate'
            ]),
            changeType(){
                this.setOldValues(this.oldValues)
            },
            initWizard(){
                this.setMedcurityBaas(this.medcurityBaasData)
                this.setOldValues(this.oldValues)
                this.setPreviousBaas(this.previousBaas)
                this.setRoutes(this.routes)
                this.setGeneralUser(this.generalUser)

                this.setBaaTemplate(this.oldValues.template_baa_id || this.oldValues.template)

                if(this.oldValues.type){
                    this.templateType = this.oldValues.type
                }
            }
        }
    }
</script>

<style scoped>
.baa-step-head{font-weight:700;color:#0b2545;font-size:1rem;margin:8px 0 6px;}
</style>
